export const content = {
  gruppenraumSingular: ' + 1 Gruppenraum',
  gruppenraumPlural: (n: number) => ` + ${n} Gruppenräume`,
};
